import { PlanReviewReviewOutcome } from "constants/field-values";

/**
 * Which drawing of Ollie to show. `neutral` is the app-wide owl; the other three
 * carry the verdict the surrounding screen is already reporting, so the character
 * never contradicts the status next to it.
 */
export type OllieMood = "neutral" | "pass" | "revisions" | "fail";

const MOOD_FILES: Record<OllieMood, string> = {
	neutral: "ollie-owl.svg",
	pass: "ollie-pass.png",
	revisions: "ollie-revisions.png",
	fail: "ollie-fail.png"
};

/** plan_review_jobs.review_outcome → mood. An unfinished job has no verdict yet. */
export const ollieMoodForOutcome = (outcome?: string | null): OllieMood => {
	switch (outcome) {
		case PlanReviewReviewOutcome.APPROVED:
			return "pass";
		case PlanReviewReviewOutcome.REVISIONS_NEEDED:
			return "revisions";
		default:
			return "neutral";
	}
};

/** The inspection equivalent: the readiness label the Ollie Status card shows. */
export const ollieMoodForReadiness = (readiness: string): OllieMood => {
	switch (readiness) {
		case "fast-lane":
			return "pass";
		case "review":
			return "revisions";
		case "not-ready":
			return "fail";
		default:
			return "neutral";
	}
};

interface OllieAvatarProps {
	mood?: OllieMood;
	className?: string;
	alt?: string;
}

const OllieAvatar = ({ mood = "neutral", className = "", alt = "Ollie AI" }: OllieAvatarProps) => (
	<img src={`${process.env.PUBLIC_URL}/assets/images/icons/${MOOD_FILES[mood]}`} alt={alt} className={className} />
);

export default OllieAvatar;
